import { connect } from 'react-redux';
import { withRouter, browserHistory } from 'react-router';
import trailingSlashIt from 'trailing-slash-it';
import idx from 'idx';
import { toggleEditRevisionsModal } from 'presentations/ducks';
import Results from 'presentations/components/results';

const mapStateToProps = (state, { location }) => {
  return {
    presentation: state.project.presentations.currentPresentation,
    revisions: idx(state, _ => _.project.presentations.currentRevisions) || [],
    handleTileSelect: (id) => browserHistory.push(`${trailingSlashIt(location.pathname)}${id}/`)
  };
}

export default withRouter(connect(mapStateToProps, {
  toggleEditModal: toggleEditRevisionsModal
})(Results));



// WEBPACK FOOTER //
// ./presentations/containers/results.js